import Quill from 'quill';
import { QuillConfig } from 'ngx-quill/config/quill-editor.interfaces';
// Plugins tiers
import ImageResizeModule from 'quill-image-resize'; // dernier à réactiver
import MagicUrlModule from 'quill-magic-url';
import 'quill-paste-smart';
import Counter from './plugins/counter';
import MultiplePlaceholders from './plugins/multiple-placeholders';

import * as ImageUpload from 'ngx-quill-upload';
import Link from 'quill/formats/link';
import HoleBlot from './blots/hole.blot';
import InsertsBlot from './blots/inserts.blot';
import LoadingImageBlot from './blots/loading-image.blot';
import VideoBlot from './blots/video.blot';

import { TextAreaEmoji } from './emoji/quill-emoji';
import { SizeStyle } from 'quill/formats/size';

export interface SelectionRange {
  length: number;
  index: number;
}

/**
 * Whitelist des tailles de police
 */
SizeStyle.whitelist = [
  '8px',
  '9px',
  '10px',
  '11px',
  '12px',
  '14px',
  '16px',
  '18px',
  '20px',
  '22px',
  '24px',
  '26px',
  '28px',
  '36px',
  '48px',
  '72px',
];

const protocolHandle = ['https://', 'http://', 'tel:', 'mailto:'];

class CustomLink extends Link {
  static sanitize(url): string {
    for (const protocol of protocolHandle) {
      if (url.startsWith(protocol) || url.startsWith('[[') || url.startsWith('{{')) {
        return url;
      }
    }
    return protocolHandle[0] + url;
  }
}

(function installNbspFix(): void {
  // Get the original method that *every* Quill instance inherits
  const original = (Quill as any).prototype.getSemanticHTML;

  // ugly patch to fix the issue with &nbsp; in Quill
  (Quill as any).prototype.getSemanticHTML = function (
    this: Quill, // explicit `this` for TS strict‑mode
    index = 0,
    length?: number,
  ): string {
    const len = length ?? this.getLength();
    const html = original.call(this, index, len);
    return html.replace(/&nbsp;|\u00A0/g, ' ').replace(/&quot;/g, '"');
  };
})();

/**
 * Enregistrement des modules
 */

try {
  Quill.register(SizeStyle, true);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/naming-convention
  const ImageResizeCtor: any = (ImageResizeModule as any).default ?? ImageResizeModule;
  Quill.register('modules/imageResize', ImageResizeCtor);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/naming-convention
  const MagicUrlCtor: any = (MagicUrlModule as any).default ?? MagicUrlModule;
  Quill.register('modules/magicUrl', MagicUrlCtor);
  // Quill.register('modules/imageResize', ImageResize);
  Quill.register('modules/counter', Counter);
  Quill.register('modules/multiplePlaceholders', MultiplePlaceholders);
  Quill.register(HoleBlot, true);
  Quill.register(InsertsBlot, true);
  Quill.register(VideoBlot, true);
  Quill.register('formats/imageBlot', LoadingImageBlot);
  // eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/no-explicit-any
  const ImageHandlerCtor: any = (ImageUpload as any).ImageHandler ?? (ImageUpload as any).default ?? ImageUpload;
  Quill.register('modules/imageHandler', ImageHandlerCtor);
  Quill.register(CustomLink, true);
  Quill.register('modules/emoji-textarea', TextAreaEmoji, true);
} catch (error) {
  console.error('Quill modules registration failed', error);
}

/**
 * Configuration de base pour tous les éditeurs Quill
 */
export const quillDefaultConfig: QuillConfig = {
  customOptions: [
    {
      import: 'formats/font',
      whitelist: ['roboto', 'serif', 'sansserif', 'monospace'],
    },
  ],
};
